<template>
  <vue-final-modal v-model="state" classes="modal-container" content-class="modal-content">
    <div class="modal__content mt-3 mb-4">

      <!-- Reusable Header -->
      <div class="container">
        <div class="row text-center justify-content-center">
          <h2 class="form-title px-5" style="font-size: 24px; line-height: 30px; color:#435666;">
            {{ policy.name }}<span :class="'policy--'+policy.status.toLowerCase()"> - {{ formatStatusText(policy.status) }}</span>
          </h2>
        </div>
      </div>
      <hr>

      <!-- Initial Content -->
      <div v-if="!showNoFormModal && !showYesFormModal">
        <p class="text-center" style="font-size: 15px; color:#435666; line-height: 24px; font-weight: 900;">
          Do You Want to Upload an
          <br>Updated Version of this Policy?
        </p>
        <div class="modal__action">
          <button @click="showNoFormModal = true" class="btn btn-warning">No</button>
          <button @click="showYesFormModal = true" class="btn btn-primary">Yes</button>
        </div>
      </div>

      <!-- Upload Prompt -->
      <div v-if="showYesFormModal" class="container">
        <form ref="policyFormRef" class="row g-0" style="gap: 0.5rem" @submit.prevent="">

          <div>
            <label class="form-label policy-type-label">Policy File
              <span class="asterisk-required">*</span>
            </label>

            <div class="btn-group mt-2" role="group" aria-label="Policy type selection">
              <button
                type="button"
                class="btn d-inline-flex align-items-center justify-content-center"
                :class="trainingPolicy.type === 'link' ? 'btn-policy-active' : 'btn-policy-inactive'"
                @click="switchType('link')"
              >
                <link-icon />
                <span>Link</span>
              </button>

              <button
                type="button"
                class="btn d-inline-flex align-items-center justify-content-center"
                :class="trainingPolicy.type === 'file' ? 'btn-policy-active' : 'btn-policy-inactive'"
                @click="switchType('file')"
              >
                <upload-icon />
                <span>Upload</span>
              </button>
            </div>

            <div class="mt-2">
              <FileUploader v-show="trainingPolicy.type == 'file'" ref="fileRef" :id="'policy'" @fileListChange="fileHandler" :acceptedFileType="'pdf'" key="file" @blur="v$.trainingPolicy.file.$touch"/>
            </div>
            <input v-show="trainingPolicy.type == 'link'" type="text" id="link" v-model.trim="trainingPolicy.link"
              @blur="v$.trainingPolicy.file.$touch()"
              @input="trainingPolicy.file = trainingPolicy.link; v$.trainingPolicy.file.$touch()"
              class="form-control mt-2" placeholder="Link" />

            <div class="fileList mx-2" v-show="trainingPolicy.currLink != '' && trainingPolicy.file == ''">
              <div>
                <span class="p-2">{{ truncatedLink(trainingPolicy.currLink) }}</span>
              </div>
            </div>

            <div v-if="v$.trainingPolicy.file.$error">
              <span class="form-text text-danger" v-for="error of v$.trainingPolicy.file.$errors" :key="error.$uid" style="display: block;">
                {{ error.$message }}
              </span>
            </div>
          </div>


          <div class="d-row d-flex" style="gap: 1rem">
            <div class="w-100">
              <label for="nextReviewDate" class="form-label" style="color:#00A0C1;">Next Review Date
                <span class="asterisk-required">*</span>
                <i class="ps-1 fa-solid fa-circle-info fa-sm" title="Next policy review should be completed within the next 12 months."
               style="cursor: pointer;"></i>
              </label>
              <Datepicker
                id="nextReviewDate"
                v-model="trainingPolicy.review_date"
                :enable-time-picker="false"
                format="dd-MMM-yy"
                placeholder="Select date"
                input-class-name="date-picker-input"
                :disabled-dates="disabledDates"
                @update:model-value="handleDate"
                :clearable="false"
              />
            </div>
          </div>

          <div style="gap: 1rem">
              <div class="w-100">
                  <label for="notes" class="form-label" style="color:#00A0C1;">Notes
                    <span class="asterisk-required">*</span>
                  </label>
              </div>
              <div class="w-100">
                  <textarea ref="textareaNotesRef" id="Notes" v-model="trainingPolicy.notes" @blur="v$.trainingPolicy.notes.$touch" class="form-control"></textarea>
              </div>
              <div class="w-100">
                  <span class="form-text text-danger" v-if="v$.trainingPolicy.notes.$error" style="display: block;">
                      Notes is required.
                  </span>
              </div>
          </div>


          <div class="g-0 d-row d-flex flex-wrap flex-md-nowrap" style="gap: 0.5rem">

            <div class="col-12 form-check align-items-center">
              <input class="form-check-input" type="checkbox" :value="true" id="isCompulsory" v-model.trim="trainingPolicy.enforce">
              <label id="compulsoryLbl" class="form-check-label" for="isCompulsory">
                <strong>Enforce immediation attestation for this policy?</strong>
              </label>
              <i class="ps-1 fa-solid fa-circle-info fa-sm" title="Ticking this box will initiate an email to all users requesting they review and accept this policy version as soon as possible."
              style="cursor: pointer; color:#00A0C1;"></i>
            </div>

          </div>
          <div class="col-12 form-check align-items-center">
            <input class="form-check-input" type="checkbox" :value="true" id="isApproved" v-model.trim="trainingPolicy.review_confirmed">
            <label id="compulsoryLbl" class="form-check-label" for="isApproved">
              Please confirm that this policy has been reviewed and approved.
            </label>
          </div>

        </form>

        <div class="modal__action">
          <button @click="closeNestedAndMainModal" class="btn btn-cancel">Cancel</button>
          <button @click="uploadVersion" class="btn btn-primary">Save</button>
        </div>
      </div>

      <!-- Nested modal for option NO -->
      <div v-if="showNoFormModal" class="container">
        <form ref="policyFormRef" class="row g-0" style="gap: 0.5rem" @submit.prevent="">
          <div class="d-row d-flex" style="gap: 1rem">
            <div class="w-100">
              <label for="nextReviewDate" class="form-label" style="color:#00A0C1;">Next Review Date
                  <span class="asterisk-required">*</span>
                 <i class="ps-1 fa-solid fa-circle-info fa-sm" title="Next policy review should be completed within the next 12 months."
               style="cursor: pointer;"></i>
              </label>
              <Datepicker
                id="nextReviewDate"
                v-model="trainingPolicy.review_date"
                :enable-time-picker="false"
                format="dd-MMM-yy"
                placeholder="Select date"
                input-class-name="date-picker-input"
                :disabled-dates="disabledDates"
                @update:model-value="handleDate"
                :clearable="false"
              />
            </div>
          </div>

          <div style="gap: 1rem">
              <div class="w-100">
                  <label for="notes" class="form-label" style="color:#00A0C1;">Notes
                  <span class="asterisk-required">*</span>
                  </label>
              </div>
              <div class="w-100">
                  <textarea ref="textareaNotesRef" id="Notes" v-model="trainingPolicy.notes" @blur="v$.trainingPolicy.notes.$touch" class="form-control"></textarea>
              </div>
              <div class="w-100">
                  <span class="form-text text-danger" v-if="v$.trainingPolicy.notes.$error" style="display: block;">
                      Notes is required.
                  </span>
              </div>
          </div>

          <div class="col-12 form-check align-items-center mb-3">
            <input class="form-check-input" type="checkbox" :value="true" id="isApproved" v-model.trim="trainingPolicy.review_confirmed">
            <label id="compulsoryLbl" class="form-check-label" for="isApproved">
              Please confirm that this Policy has been reviewed and approved and no updates are currently required.
            </label>
          </div>

        </form>

        <div class="modal__action">
          <button @click="closeNestedAndMainModal" class="btn btn-cancel">Cancel</button>
          <button @click="updateReviewDate" class="btn btn-primary">Save</button>
        </div>
      </div>

    </div>
  </vue-final-modal>
</template>


<script>
import moment from 'moment';
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import appHelper from '@/helpers/helper';
import FileUploader from '@/components/FileUploader.vue';
import LinkIcon from '@/components/policies/assets/LinkIcon.vue';
import UploadIcon from '@/components/policies/assets/UploadIcon.vue';


export default {

  components: {
    FileUploader,
    LinkIcon,
    UploadIcon,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    policy: {
      type: Object,
      required: true
    }
  },

  setup () {
    return { v$: useVuelidate() }
  },

  validations() {
      return {
        trainingPolicy: {
          notes: { required },
          file: {
            required: helpers.withMessage('Link is required.', required),
            validUrl: helpers.withMessage('Please enter a valid URL (e.g., https://example.com).', function(value) {
              if (this.trainingPolicy.type === 'file') return true;
              if (!value) return true;
              return appHelper.isValidUrl(value);
            })
          },
         },
      }
   },

  data() {
    return {
      state: this.dialog,
      showNoFormModal: false,
      showYesFormModal: false,
      selectedFile: null,
      isDateValid: false,

      trainingPolicy: {
        id: 0,
        name: '',
        link: '',
        compulsory: false,
        version: '',
        videoID: '',
        object: '',
        type: 'link',
        file: '',
        currLink: '',
        status: '',
        owner: 0,
        created_at: 0,
        review_date: 0,
        original_review_date: null,
        review_confirmed: false,
        enforce: false,
      },
    };
  },

  mounted() {
    this.trainingPolicy.id = this.policy.ID ? this.policy.ID : this.policy.id
    this.trainingPolicy.name = this.policy.name
    this.trainingPolicy.currLink = this.policy.link
    this.trainingPolicy.link = this.policy.link
    this.trainingPolicy.file = this.policy.link
    this.trainingPolicy.compulsory = this.policy.required
    this.trainingPolicy.version = this.policy.version
    this.trainingPolicy.owner = this.policy.owner
    this.trainingPolicy.status = this.policy.status
    this.trainingPolicy.created_at = this.policy.CreatedAt
    this.trainingPolicy.original_review_date = this.policy.review_date
    this.trainingPolicy.notes = this.policy.notes

    // Set default review date to today + 12 months
    this.trainingPolicy.review_date = moment().add(12, 'months').toDate();

    if (this.policy.training_videos && this.policy.training_videos.length != 0) {
      this.trainingPolicy.videoID = this.policy.training_videos[0].ID
    }
  },

  watch: {
    dialog(newVal) {
      this.state = newVal;
    }
  },
  methods: {

    handleDate(newDate) {
      const today = new Date();
      const selectedDate = new Date(newDate);

      // Clear previous error message
      this.errorMessage = '';

      // Calculate the date that is 12 months from today
      const maxDate = new Date(today);
      maxDate.setMonth(today.getMonth() + 12);

      // Check if the selected date is before today
      if (selectedDate < today) {
        this.$toast.error("The selected date cannot be before today.");
        this.trainingPolicy.review_date = this.trainingPolicy.original_review_date; // Reset to original review date
        this.isDateValid = false; // Invalid date
      }
      // Check if the selected date is more than 12 months ahead
      else if (selectedDate > maxDate) {
        this.$toast.error("The selected date cannot be more than 12 months from today.");
        this.trainingPolicy.review_date = this.trainingPolicy.original_review_date; // Reset to original review date
        this.isDateValid = false; // Invalid date
      }
      else {
        this.trainingPolicy.review_date = newDate;
        this.isDateValid = true; // Valid date
      }
    },

    async updateReviewDate() {

      const isFormCorrect = await this.v$.$validate()

      if (!isFormCorrect) {
        return
      }

      if (!this.trainingPolicy.review_confirmed) {
          this.$toast.error("Please confirm that this Policy has been reviewed and approved.");
          return;
      }

      this.$emit("onReviewDateChange", {
          data: {
              policy_id: this.trainingPolicy.id,
              next_review_date: this.trainingPolicy.review_date,
              notes: this.trainingPolicy.notes
          }
      });

      this.closeNestedAndMainModal();
    },

    closeAllModals() {
      this.showConfirmationModal = false;
      this.state = false; // Close the main modal
    },
    saveChanges() {
      // Logic to save changes, if applicable
      this.closeAllModals(); // Close modals after saving changes
    },
    closeNestedAndMainModal() {
      this.showNestedModal = false;
      this.state = false;
    },
    closeNested() {
      this.showNestedModal = false;
    },
    closeDialog() {
      this.$emit('close');
      this.state = false;
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
    },

    async uploadVersion() {

      const isFormCorrect = await this.v$.$validate()

      if (!isFormCorrect) {
        return
      }

      if (!this.trainingPolicy.review_confirmed) {
        this.$toast.error("Please confirm that this Policy has been reviewed and approved.");
        return;
      }

      // Logic for uploading the selected file
      this.$emit("uploadNewVersion", { data: this.trainingPolicy });
      this.closeDialog(); // Close the modal after upload
    },

    formatStatusText(format) {
      return format
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },

    truncatedLink(link) {
      const maxLength = 50;


      let truncated = link.substring(0, maxLength);
      if (link.length > maxLength) {
        truncated += '...';
      }

      return truncated;
    },

    formatDate(utcDate) {
      return moment.utc(utcDate).local().format('D-MMM-YYYY');
    },

    switchType(newType) {
      this.trainingPolicy.type = newType;

      if (this.trainingPolicy.type === 'link') {
        this.trainingPolicy.file = this.trainingPolicy.link || '';
      } else if (this.trainingPolicy.type === 'file') {
        this.trainingPolicy.file = this.trainingPolicy.object || '';
      }

    },

    fileHandler(files){
      if (files.files.length != undefined)
      {
        this.trainingPolicy.object = ''
        this.trainingPolicy.file = ''
      } else {
        this.trainingPolicy.object = files;
        this.trainingPolicy.file = files;
      }
    },


  },

  computed: {
    formattedReviewDate() {
      if (this.trainingPolicy.review_date == null) {
        return ""
      }

      return this.formatDate(this.trainingPolicy.review_date);
    },

    disabledDates() {
      // Get today's date
      const today = new Date();

      // Calculate the date 12 months from today
      const maxReviewDate = new Date(today);
      maxReviewDate.setMonth(today.getMonth() + 12);

      return (date) => {
        // Disable dates before today or after 12 months from today
        return date < today || date > maxReviewDate;
      };
    }

  }

};
</script>



<style scoped>
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Label Styling */
.policy-type-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #00A0C1 !important;
  font-weight: 500;
}

/* Common button styles */
.btn-group .btn {
  height: 24px;
  padding: 0; /* Reset padding to center content in fixed-size box */
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out;
  border: 1px solid #ced4da;
  white-space: nowrap;
}

/* --- INDIVIDUAL BUTTON WIDTHS FROM FIGMA --- */
.btn-group .btn:first-child {
  width: 68px; /* Link button width */
}
.btn-group .btn:last-child {
  width: 79px; /* Upload button width */
}
/* ------------------------------------------- */


/* Active Button State */
.btn-group .btn.btn-policy-active {
  background-color: #28a7b9;
  border-color: #28a7b9;
  color: white;
  z-index: 2;
  font-weight: 700;
}

/* Inactive Button State */
.btn-policy-inactive {
  background-color: #ffffff;
  color: #556371;
}
.btn-policy-inactive:hover {
  background-color: #f8f9fa;
}

/* SVG Color Control */
.link-svg path {
  fill: currentColor;
}
.upload-svg path {
  stroke: currentColor;
}

/* Correct Border Radius */
.btn-group > .btn:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.btn-group > .btn:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

:deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff !important;
  width: 444px !important;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.2rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center; /* Center the buttons */
  gap: 1rem; /* Add space between the buttons */
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

@media screen and (max-width: 900px) {
:deep(.modal-content) {
  width: 95%;
}
}



/* policy status tags */
.policy--current {
   color: #00A54F;
}

.policy--review_required {
  color: #F3994D;
}

.policy--review_overdue {
color: #EB1C24;
}

/* override btn designs for modal pop-ups */
.btn-warning {
  border-radius: 10px;
  width: 120px;
  height: 40px;
}
/* override btn designs for modal pop-ups */
.btn-primary {
  border-radius: 10px;
  width: 120px;
  height: 40px;
}

/* override btn designs for modal pop-ups */
.btn-cancel {
  border-radius: 10px;
  width: 120px;
  height: 40px;
}


select>option{
  color: #435666;
  font-size:14px !important;
}

form label:not(#compulsoryLbl){
   color: #00A0C1;
   margin: 0.5rem 0;
}

input:not([type="checkbox"]), select {
   height: 40px;
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

/* Style to hide spinner for number input in Bootstrap 5 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.btn.disabled, .btn:disabled, fieldset:disabled .btn {
	color: white;
	pointer-events: none;
	background-color: #435666;
	border-color: #435666;
	opacity: .5;
}
</style>
